// extracted by mini-css-extract-plugin
export default {"productDescription":"Taa-z","featuredDescription":"Uaa-z","description":"Vaa-z","more":"Waa-z","descriptionSku":"Xaa-z"};